import { text_to_slug } from "../../../util/methods"

$(document).on("turbolinks:load", function () {
  var $bundlesForm = $(".js-productBundle-form")

  if ($bundlesForm.length > 0) {
    // sluggify bundle title
    $("#product_bundle_title").on("keyup", function () {
      $("#product_bundle_slug")
        .val(text_to_slug($(this).val()))
        .trigger("input")
    })

    // format rate input
    $(".rate-in-percent").on("change", function () {
      let val = $(this).val()
      let newVal = parseFloat(val) / 100
      $("#js-productBundle-data-box-creator-commission").text(`${val}%`)
      $(this).closest(".rate-form-group").find(".rate-in-decimal").val(newVal)
    })

    // update price in data-box
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    })

    $(".price-in-dollars").on("change", function () {
      let value = $(this).val()
      $("#js-productBundle-data-box-price").text(formatter.format(value))
    })

    // scheduling
    var $bundleSchedulingContainer = $("#js-productBundle-scheduling")
    if ($bundleSchedulingContainer.length > 0) {
      var $datePickersContainer = $(".js-productBundle-date-pickers")

      $("#product_bundle_time_limited").on("change", function () {
        if ($(this).is(":checked")) {
          $datePickersContainer.show()
        } else {
          $datePickersContainer.hide()
          $(".js-datetimepicker").val("")
        }
      })
    }
  }
})
